import { APP_PERMISSIONS } from './permission.constants';

/**
 * Permissions exclusive to Version 2 (hazard/climate/vulnerability/assessment), gated behind the
 * `version2FeaturesV1` feature flag (CR-299). Every other permission (essentials, evaluations,
 * reference data, users, roles) is Version 1 or shared and must never be added here.
 */
export const V2_EXCLUSIVE_PERMISSIONS: ReadonlySet<string> = new Set([
  APP_PERMISSIONS.AssessmentsRead,
  APP_PERMISSIONS.AssessmentsCreate,
  APP_PERMISSIONS.AssessmentsUpdate,
  APP_PERMISSIONS.AssessmentsComplete,
  APP_PERMISSIONS.AssessmentClimateImpactRead,
  APP_PERMISSIONS.AssessmentClimateImpactWrite,
  APP_PERMISSIONS.AssessmentVulnerabilityRead,
  APP_PERMISSIONS.AssessmentVulnerabilityWrite,
  APP_PERMISSIONS.AssessmentHazardsRead,
  APP_PERMISSIONS.HazardCatalogRead,
  APP_PERMISSIONS.HazardFamiliesRead,
  APP_PERMISSIONS.HazardFamiliesCreate,
  APP_PERMISSIONS.HazardFamiliesUpdate,
  APP_PERMISSIONS.HazardFamiliesDelete,
  APP_PERMISSIONS.HazardsRead,
  APP_PERMISSIONS.HazardsCreate,
  APP_PERMISSIONS.HazardsUpdate,
  APP_PERMISSIONS.HazardsDelete,
  APP_PERMISSIONS.HazardBaselineLevelsRead,
  APP_PERMISSIONS.HazardBaselineInputsRead,
  APP_PERMISSIONS.HazardBaselineInputsWrite,
  APP_PERMISSIONS.HazardBaselineRead,
  APP_PERMISSIONS.HazardBaselineCalculate,
  APP_PERMISSIONS.RegionalClimateReferenceRead,
  APP_PERMISSIONS.RegionalClimateReferenceCreate,
  APP_PERMISSIONS.RegionalClimateReferenceUpdate,
  APP_PERMISSIONS.RegionalClimateReferenceToggleStatus,
  APP_PERMISSIONS.ClimateVariableRead,
  APP_PERMISSIONS.ClimateVariableCreate,
  APP_PERMISSIONS.ClimateVariableUpdate,
  APP_PERMISSIONS.ClimateVariableToggleStatus,
  APP_PERMISSIONS.HazardFamilyClimateVariableRead,
  APP_PERMISSIONS.HazardFamilyClimateVariableCreate,
  APP_PERMISSIONS.HazardFamilyClimateVariableToggleStatus,
  APP_PERMISSIONS.ClimateScenarioRead,
  APP_PERMISSIONS.ClimateScenarioCreate,
  APP_PERMISSIONS.ClimateScenarioUpdate,
  APP_PERMISSIONS.ClimateScenarioToggleStatus,
  APP_PERMISSIONS.LocalNationalClimateReferenceRead,
  APP_PERMISSIONS.LocalNationalClimateReferenceCreate,
  APP_PERMISSIONS.LocalNationalClimateReferenceUpdate,
  APP_PERMISSIONS.LocalNationalClimateReferenceToggleStatus,
  APP_PERMISSIONS.VulnerabilityIndicatorsRead,
  APP_PERMISSIONS.VulnerabilityCalculationCalculate,
]);
